import React, { useEffect, useState, useRef } from "react";
import moment from "moment/moment";
import axios from "axios";
import Card from "@mui/material/Card";
import RefreshIcon from "@mui/icons-material/Refresh";
import * as SiIcons from "react-icons/si";
import { useRecoilValue } from "recoil";
import DataTable from "../../../Components/DataTable/DataTable";
import Loading from "../../../Components/Loading/Loading";
import DateRange from "../../../Components/DateRange/DateRange";
import ExportExcel from "../../../Components/ExportExcel/ExportExcel";
import {
    AlertError,
    AlertSuccess,
    AlertWarning,
} from "../../../Components/AlertDialog/AlertDialog";
import { userData } from "../../../DataContext/DataContext";
import { authorization, UrlApi } from "../../../UrlApi/UrlApi";
import { ButtonOther } from "../../../Components/Button/Button";


const DataDeletionReport = () => {
    const user = useRecoilValue(userData);
    const [loading, setLoading] = useState(false);
    const [reportData, setReportData] = useState([]);
    const refContainer = useRef(null);
    const [pageSize, setPageSize] = useState(50);
    const [date, setDate] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: "selection",
        },
    ]);
    const [variable, setVariable] = useState({
        startDate: new Date(),
        endDate: new Date(),
    });

    const columns = [
        {
            title: "ลำดับ",
            field: "list_no",
            filtering: false,
            width: "5rem",
        },
        {
            title: "วันที่ลบข้อมูล",
            field: "delete_date",
            height: 10,
            width: "10rem",
        },
        {
            title: "เวลาที่ลบ",
            field: "delete_time",
            height: 10,
            width: "10rem",
        },
        {
            title: "จำนวนเอกสารที่ลบ",
            field: "log_delete_transaction_docqty",
            type: 'numeric',
            height: 10,
            width: "10rem",
        },
        {
            title: "สถานะ",
            field: "log_delete_transaction_status",
            height: 10,
            width: "10rem",
        },
        {
            title: "จำนวนวัน",
            field: "set_time_day",
            type: 'numeric',
            height: 10,
            width: "50%",
            textAlign: 'left',
            cellStyle: { width: "100%", maxWidth: "100%" ,textAlign: 'left',paddingLeft:"70px"},
        },
    ];

    useEffect(() => {
        getData(variable.startDate, variable.endDate)
    }, [variable, date])

    function datePicker() {
        return (
            <>
                <DateRange
                    onClick={(date) => {
                        variable.startDate = date[0].startDate;
                        variable.endDate = date[0].endDate;
                        getData(date[0].startDate, date[0].endDate);
                    }}
                />
            </>
        );
    }

    const getData = async (startDate, endDate) => {
        const url =
            UrlApi +
            `data_deletion_report?start_date=${moment(startDate).format("YYYY-MM-DD")}&end_date=${moment(endDate).format("YYYY-MM-DD")}`;
        await axios
            .get(url, authorization)
            .then((res) => {
                res.data.map((e, idx) => {
                    e.list_no = idx + 1
                })
                setReportData(res.data);
            })
            .catch((err) => {
                AlertError(err);
            });
    };

    const exportExcells = () => {
        let columnExport = [];
        columns.map((item) => {
            if (item.title !== "เปิด") {
                columnExport.push(item.title);
            }
        });

        const header = [
            "",
            "รายงานประจำวันที่ " +
            moment(variable.startDate).format("DD/MM/YYYY") +
            " ถึง " +
            moment(variable.endDate).format("DD/MM/YYYY"),
        ];
        const data = reportData.map((item) => {
            return [
                item.list_no,
                item.delete_date,
                item.delete_time,
                item.log_delete_transaction_docqty,
                item.log_delete_transaction_status,
                item.set_time_day
            ];
        });
        ExportExcel(
            data,
            columnExport,
            'รายงานการลบข้อมูลการวิ่งงาน',
            "รายงานการลบข้อมูลการวิ่งงาน.xlsx",
            header,
        );
    };

    const HeaderPage = () => {
        return (
            <>
                <div style={{ paddingTop: "10px" }}>
                    <label
                        style={{ marginLeft: "10px", marginTop: "10px", fontSize: "18px" }}
                    >
                        รายงานการลบข้อมูลการวิ่งงาน
                    </label>
                    <div
                        style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                            }}
                        >
                            {datePicker()}
                            <div style={{ marginLeft: '38px' }}>
                                <ButtonOther
                                    onClick={() => {
                                        getData(variable.startDate, variable.endDate);
                                    }}
                                    message="โหลดข้อมูลใหม่"
                                    width="20ch"
                                    startIcon={<RefreshIcon />}
                                    background="#61C495"
                                />
                            </div>
                        </div>
                        <div
                            style={{
                                display: "flex",
                            }}
                        >
                            <div style={{ marginRight: "12px", marginTop: "2px" }}>
                            </div>
                            {
                                <ButtonOther
                                    onClick={() => {
                                        exportExcells();
                                    }}
                                    message="ส่งออก"
                                    width="15ch"
                                    startIcon={<SiIcons.SiMicrosoftexcel />}

                                />
                            }
                        </div>
                    </div>
                </div>
            </>
        );
    };

    return (
        <>
            <Card
                variant="outlined"
                style={{
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    borderRadius: "10px",
                }}
            >
                {HeaderPage()}
                <DataTable
                    exportButton={false}
                    columns={columns}
                    data={reportData}
                    width="100%"
                    countRowData={reportData.length}
                    pageSize={pageSize}
                    options={{
                        headerStyle: {
                            textAlign: 'center',
                        },
                        cellStyle: {
                            textAlign: 'left',
                        },
                    }}
                />
            </Card>
            <Loading open={variable.loading} />
        </>
    )
};

export default DataDeletionReport;
